import { Stack, Alert } from '@mui/material';
import React, { useState } from 'react';

import DiscernUpload from '@components/DiscernUpload/DiscernUpload';
import PatientDiscernTable from '@components/PatientDiscernTable';

interface PatientDiscernUploadProps {
  vitallPatientId: string;
  patientName: string;
}

const PatientDiscernUpload: React.FC<PatientDiscernUploadProps> = ({
  vitallPatientId,
  patientName,
}) => {
  const [uploadComplete, setUploadComplete] = useState(false);

  const handleUploadComplete = () => {
    setUploadComplete(true);
  };

  return (
    <Stack spacing={3}>
      {/* Upload Component with Patient Context - Moved to top */}
      <DiscernUpload
        vitallPatientId={vitallPatientId}
        patientName={patientName}
        onUploadComplete={handleUploadComplete}
      />

      {/* Upload Success Message */}
      {uploadComplete && (
        <Alert severity="success">
          PDF uploaded successfully! You can now process and split the pages
          using the editor below.
        </Alert>
      )}

      {/* Patient Files Table */}
      <PatientDiscernTable
        vitallPatientId={vitallPatientId}
        patientName={patientName}
      />
    </Stack>
  );
};

export default PatientDiscernUpload;
